import React from 'react';
import SelectStepTemplate from '../../../template/SelectStepTemplate';
import useGetMateriais, {
  buildOutrosTecidos,
} from '../../../template/UseGetMateriais';
import TipoDivergenciasInfoKey from '../../../TipoDivergenciasInfoKey.';
import { TipoDivergenciaComponent } from '../../../TiposDeDivergencias';
import { UploadQualidadeTecidoStep } from '../../upload-step';


const QualidadeDoTecido: TipoDivergenciaComponent = ({ onSetStep, onBack }) => {
  const { loading, materiais } = useGetMateriais(
    TipoDivergenciasInfoKey.TECIDO
  );
  const newMateriais = [...materiais, buildOutrosTecidos()];

  const stepNumber = '2';
  const stepSubTitle = 'Selecione o tecido com o problema de qualidade.';
  const stepTitle = 'Qual tecido está com problema de qualidade?';
  return (
    <SelectStepTemplate
      data={newMateriais}
      loading={loading}
      nextStepComponent={UploadQualidadeTecidoStep as TipoDivergenciaComponent}
      onBack={onBack}
      onSetStep={onSetStep}
      payloadKey='tecidos'
      stepNumber={stepNumber}
      stepSubTitle={stepSubTitle}
      stepTitle={stepTitle}
    />
  );
};

export default QualidadeDoTecido;
